import React, { useState } from "react";
import Input from "./Input";
import { handleClick } from "./Alert";
import styles from "../NotesPage.module.scss";
import { PostNotes, getNotesData } from "service/NotesService";
import Notification from "utils/Notifications";
import { Button } from "components";
import ModalWindow from "hooks/ModalWindow/ModalWindow";


const Content = ({ setNotes }) => {
  const [openModal, setOpenModal] = useState(false);
  // const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [notesdata, setData] = useState([]);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const handleSubmit = async (event) => {
    event.preventDefault();
   
    if (!body) {
      setNotify({
        isOpen: true,
        message: "Заполните все поля!",
        type: "error",
      });
   
    }
    else{
      const formData = new FormData();
    // formData.append('title',title);
    formData.append('body', body);
    
   
    let noteinfo = await PostNotes(formData);
    const iddata = noteinfo.data.id
    const createdAtdata = noteinfo.data.createdAt
    const note = { id: iddata, body, archived: false, createdAt: createdAtdata};

    setNotes((prevNotes) => [...prevNotes, note]);
  
    setBody("");
    setOpenModal(false)
    setNotify({
      isOpen: true,
      message: "Заметка успешно создана!",
      type: "success",
      sound: "success"
    });
    }
    
  };
  const handleEmojiSelect = (emoji) => {
    setBody(body + emoji);
  };
  return (
    <div className={styles["note-input"]}>
         <button
                  onClick={() => setOpenModal(true)}
                >
                  Создать заметку
                </button>
      
      <ModalWindow
        openModal={openModal}
        setOpenModal={setOpenModal}
        modalText={'Новая заметка'}
      >
        <>
        <div className={styles["note-input"]}>
        {/* <h2>Новая Заметка</h2> */}
      <form onSubmit={handleSubmit} >
        {/* <p className={styles["note-input__title__char-limit"]}>
        Оставшиеся символы: {50 - title.length}
        </p>
        <Input
      
          value={title}
          onChange={setTitle}
          name="title"
          type="text"
          placeholder="Введите тему"
        />
       */}
      
        <Input

          value={body}
          onChange={setBody}
          name="body"
          type="textarea"
          placeholder="Пишите свои заметки здесь..."
        />
        
      
        <button
          type="submit"
          className={styles["create-btn"]}
         
        >
          Создать
        </button>
      </form>
</div>
<br></br>
          <Button
            onClick={() => setOpenModal(false)}
            className={styles.btn_pin_close}
          >
            {" "}
            Закрыть
          </Button>
        </>
      </ModalWindow>
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  );
};

export default Content;
